import { useMemo } from 'react';
import { alpha } from '@mui/material/styles';
import { Button, Text } from 'components/ui';
import { getCssPx } from 'components/ui/utilities/zoom';
import { AuthSelectionListProps } from './AuthSelectionList.props';
import { AuthSelectionListRoot } from './AuthSelectionList.styles';

const AuthSelectionList = ({ loadingValue = null, onSelect, options, selectedValue }: AuthSelectionListProps) => {
  const enabledOptions = useMemo(() => options.filter(option => !option.disabled), [options]);
  const hasPendingSelection = loadingValue !== null;

  return (
    <AuthSelectionListRoot>
      {enabledOptions.map((option, index) => (
        <Button
          autoFocus={selectedValue ? selectedValue === option.value : index === 0}
          data-auth-selection-item="true"
          data-testid={option.testId}
          disabled={hasPendingSelection}
          fullWidth
          id={`auth-selection-${option.value}`}
          key={option.value}
          loading={loadingValue === option.value}
          loadingBehavior="inline"
          onClick={() => onSelect(option.value)}
          sx={{
            backgroundColor: 'background.paper',
            borderColor: 'primary.main',
            borderRadius: '4px',
            borderStyle: 'solid',
            borderWidth: 1,
            boxSizing: 'border-box',
            color: 'primary.main',
            gap: '8px',
            height: getCssPx(50),
            justifyContent: 'center',
            paddingX: getCssPx(32),
            paddingY: getCssPx(16),
            textAlign: 'center',
            '&:hover': {
              backgroundColor: theme => alpha(theme.palette.primary.main, 0.04),
              borderColor: 'primary.main',
            },
          }}
          type="button"
          variant="text"
        >
          <Text
            sx={{
              color: 'primary.main',
              fontSize: 16,
              fontWeight: 600,
              letterSpacing: '0.08em',
              lineHeight: 1.125,
              whiteSpace: 'nowrap',
              textTransform: 'uppercase',
            }}
          >
            {option.title}
          </Text>
        </Button>
      ))}
    </AuthSelectionListRoot>
  );
};

export default AuthSelectionList;
